<template>
  <v-card
    :loading="loading"
    class="mx-auto mb-4"
    tile
    width="100%"
  >
    <div class="image-container">
      <figure
        class="instagram-filter"
      >
        <v-img
          class="grey lighten-4"
          height="400"
          :src="page.card_image_url"
        >
        </v-img>
      </figure>
      <div class="overlay-border-container"
      >
        <div class="overlay-border">
          <div
            v-if="this.$gd.text['card-title-over-image']"
            class="overlay-heading">
            {{ page.heading }}
          </div>
        </div>

      </div>

    </div>

    <v-card-text
      v-if = "!this.$gd.text['card-title-over-image']"
      class="fixed-height"
    >
      <div class="text-page-heading">
        {{ page.heading }}
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <primary-button
        color="primary accent-4"
        text
        :to="{ name: 'pages.show', params: { slug: page.slug }}"
      >
        {{ $t('Read More')}}
      </primary-button>
    </v-card-actions>
  </v-card>
</template>

<style scoped>

  .fixed-height {
    height: calc(100% - 400px - 52px);
  }

  .image-container {
    position: relative;
    overflow: hidden;
  }

  .overlay {
    z-index: 0;
    width: 100px;
    height: 100px;
    overflow: auto;
    bottom: -50px;
    left: 0;
    position: absolute;
  }

  .overlay-dots {
    height: 100px;
    width: 100px;
    bottom: 0;
    position: absolute;
    background-image: radial-gradient(white 30%, transparent 32%),
    radial-gradient(white 30%, transparent 32%);
  background-size: 30px 30px;
    background-position: 0 0, 15px 15px;
    background-repeat: repeat;
    -webkit-mask-image: -webkit-gradient(linear, left bottom,
    right top, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
    border-top-right-radius: 100px;
  }

  .overlay-border-container {
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0;
    position: absolute;
  }

  .overlay-border {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    margin: 10px;
    /*border: 1px solid #f1f1f1;*/
    position: relative;
  }

  .overlay-heading {
    width: 100%;
    height: auto;
    bottom: 0;
    z-index: 100;
    position: absolute;
    padding: 20px;
    text-shadow: 0 0 10px #000;
    color: #ffffff;
    font-size: 40px;
    line-height: 45px;
    font-weight: 800;
  }

  .text-page-heading {
    font-size: 24px;
    line-height: 28px;
    color: #333333;
    font-weight: 600;
    padding: 10px 0;
  }

</style>

<script>

  export default {
    name: 'PageTile',
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    components: {},
  };
</script>
